import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../service/auth.service';

export function jwtInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Inject the AuthService to access the authentication token
  const authService = inject(AuthService);

  // Skip for auth endpoints or if no token exists
  const skipAuth = req.url.includes('/login')
    || req.url.includes('/refreshToken')
    || req.url.includes('/refresh-token')
    || req.url.includes('/register')
    || req.url.includes('/logout');

  if (skipAuth || !authService.accessToken) {
    return next(req);
  }

  // Clone the request and add the authorization header
  const reqWithAuth = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authService.accessToken}`
    }
  });

  return next(reqWithAuth);
}